import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useLookups() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    api.get("/lookups").then((r) => { cache = r.data; setData(r.data); });
  }, []);
  return data;
}

export const toOpts = (list = [], keepId) => list.filter((x) => x.active !== false || x.id === keepId).map((x) => ({ value: x.id, label: x.name }));
